import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getCampaign } from "../services/api";
import { CampaignData } from "../types";

export const DEFAULT_CAMPAIGN: CampaignData = {
  purchaseUrl: "https://www.academiarafaeltoro.com.br/",
  luckyNumbersUrl: "#",
  regulationUrl: "https://arquivos.academiarafaeltoro.com.br/uploads/Academia+Rafael+Toro+-+Regulamento+autorizado.pdf",
  certificateNumber: "Certificado de Autorização SPA/ME N° 04.051074/2026",
  schedule: [
    { title: "Início da Promoção!", date: "16 de julho de 2026" },
    {
      title: "Fim do Período de Participação",
      extraDescription: "(Último dia para comprar)",
      date: "07 de dezembro de 2026",
    },
    { title: "Sorteio", extraDescription: "(Loteria Federal)", date: "16 de dezembro de 2026" },
    { title: "Apuração Oficial", extraDescription: "(às 10:00)", date: "23 de dezembro de 2026" },
    {
      date: "icon",
      title: "Divulgação do vencedor",
      extraDescription: "(Em até 30 dias após a apuração!)",
    },
  ],
};

interface CampaignContextValue {
  campaign: CampaignData;
  loading: boolean;
  error: string | null;
  retry: () => void;
}

const CampaignContext = createContext<CampaignContextValue | undefined>(
  undefined
);

export function CampaignProvider({ children }: { children: React.ReactNode }) {
  const [campaign, setCampaign] = useState<CampaignData>(DEFAULT_CAMPAIGN);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCampaign = useCallback(() => {
    setLoading(true);
    setError(null);

    getCampaign()
      .then((data) => setCampaign({ ...DEFAULT_CAMPAIGN, ...data }))
      .catch(() => {
        setError(
          "Não foi possível carregar os dados da campanha. Algumas informações podem estar indisponíveis."
        );
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchCampaign();
  }, [fetchCampaign]);

  const value = useMemo(
    () => ({ campaign, loading, error, retry: fetchCampaign }),
    [campaign, loading, error, fetchCampaign]
  );

  return (
    <CampaignContext.Provider value={value}>
      {children}
    </CampaignContext.Provider>
  );
}

export function useCampaign(): CampaignContextValue {
  const context = useContext(CampaignContext);

  if (!context) {
    throw new Error("useCampaign deve ser usado dentro de CampaignProvider");
  }

  return context;
}
